export default {
      id: "icon-question-usage",
      viewBox: "0 0 28 28",
      url: __webpack_public_path__ + "svg-sprite-defs.svg#icon-question",
      toString: function () {
        return this.url;
      }
    }